import { chatParticipantOneOnOne } from "./iam.utils";

export const iamConstants = {
    MESSENGER_APP_TITLE: 'YPO Messenger',
    PREVIEW_VERSION: '1.0',
    PREVIEW_MESSAGE: '<p>Thank you for piloting YPO Messenger 1.0.</p><p>New feature enhancements coming soon!</p>',
    DEFAULT_CONVERSATION_TITLE: 'New Conversation',
    PARTICIPANT_LEFT_TITLE: 'Participant left this chat',
    DEVICE_DISPLAY_NAME: 'YPO Connect Web Platform',
    ADD_PARTICIPANTS: 'Find someone to the add to conversation',
    TYPEAHEAD_PROMPT: 'Type part of a person\'s name...',
    LOADING_TYPEAHEAD_RESULTS: 'Loading...',
    NO_RESULTS: 'No results.',
    DELETE_CONVERSATION: 'Delete conversation',
    DELETE_CONVERSATION_TITLE: 'Are you sure?',
    DELETE_CONVERSATION_MESSAGE: 'Deleting this conversation will not remove any of your connections; however, everyone will lose access to the conversation history.',
    CREATE_NEW_YPO_MESSENGER_GROUP: 'Create New YPO Messenger Group',
    NEW_GROUP_CHAT_PLACEHOLDER: 'Name your new YPO Messenger group',
    NEW_MESSENGER_GROUP: 'New Messenger Group',
    MESSAGE_GROUP: 'Message Group',
    DRAFT_CHAT_ID: '__draft__',
    MAX_PARTICIPANTS: 250,
    GROUP_NAME_MAX: 25,
    PARTICIPANTS: 'Participants',
    ADD_PARTICIPANTS_TO_GROUP: 'Add Participants',
    SEARCH_PLACEHOLDER_IN_GROUP: 'Type the name of a YPO Connection to quickly find them',
    defaultPanel: {
        features: {
            searchAndConnect: {
                HEADLINE: 'Search and Connect with other YPO Members',
                BODY: 'Get instant access to the members most important to you',
            },
            chatInstantly: {
                HEADLINE: 'Chat instantly with your new connections',
                BULLETS: [
                    'Create your own message groups',
                    'Chat together or network one-to-one',
                    'Fully encrypted, 100% private and secure',
                ],
            },
        },
    },
    powerLevel: {
        MAX: 100,
        MIN: 0,
    },
};

export const newGroupChatObject = () => {
    return {
        id: iamConstants.DRAFT_CHAT_ID,
        participants: {},
        events: [],
        name: '',
    };
};

export const newDraftConversation = () => {
    return {
        id: iamConstants.DRAFT_CHAT_ID,
        participants: {},
        events: [],
    };
};

const reportConversationOption = {
    key: 'reportConversation',
    label: 'Report Conversation',
    clickHandler: 'setSelectedMenuOption',
    isVisible: true,
    actionData: {
        title: 'Report This Conversation',
        body: '<p>YPO members must accept the YPO Community Standards in compliance with YPO Policies and Procedures. Members are ' +
            'responsible for the conduct of their family members within the YPO community.</p><p>To report a violation of the ' +
            ' Community Standards of Policies and Procedures that occurred within YPO Messenger, please take a screenshot of ' +
            'the violation and <a href="mailto:ask@ypo.org?subject=YPO Messenger: Report Conversation">email it to us</a> ' +
            'with a description of the event.</p><p>Thank you for helping us preserve our elite community of global leaders.</p>',
        cancelButton: 'Cancel',
        onCancel: 'cancelDialogAction',
    },
};

//making it a function as we will have to send data from conversation/member to get dynamic data
export const oneOnOneConversationMenu = (conversation, messengerUsername) => {
    const oneOnOneChatParticipant = chatParticipantOneOnOne(conversation, messengerUsername);

    return [
        {
            key: 'deleteConversation',
            label: 'Delete Conversation',
            clickHandler: 'setSelectedMenuOption',
            isVisible: true,
            actionData: {
                title: 'Are you sure?',
                body: 'Deleting this conversation will not remove any of your connections; however, everyone will lose access to the conversation history.',
                cancelButton: 'Cancel',
                confirmButton: 'Delete',
                onCancel: 'cancelDialogAction',
                onConfirm: 'confirmDeleteConversation',
            },
        },
        {
            key: 'removeConnection',
            label: 'Remove Connection',
            clickHandler: 'setSelectedMenuOption',
            isVisible: true,
            actionData: {
                title: 'Are you sure?',
                body: `You can only use YPO Messenger to chat with your connections. Removing 
                ${`<strong>${oneOnOneChatParticipant.name}</strong>` || 'this member'} from your connections will also delete your conversation history.`,
                cancelButton: 'Cancel',
                confirmButton: 'Continue',
                onCancel: 'cancelDialogAction',
                onConfirm: 'confirmRemoveConnection',
            },
        },
        reportConversationOption,
        {
            key: 'policiesAndProcedures',
            label: 'Policies and Procedures',
            clickHandler: 'launchPnP',
            isVisible: true,
        },
    ];
};

export const groupConversationMenu = (canEdit, canManage, canRename) => {
    return [
        {
            key: 'deleteGroup',
            label: 'Delete Group',
            clickHandler: 'setSelectedMenuOption',
            isVisible: canEdit,
            actionData: {
                title: 'Are you sure?',
                body: 'Deleting this group will not remove any of your connections; however, everyone will lose access to the conversation history.',
                cancelButton: 'Cancel',
                confirmButton: 'Delete',
                onCancel: 'cancelDialogAction',
                onConfirm: 'confirmDeleteConversation',
            },
        },
        {
            key: 'leaveGroup',
            label: 'Leave Group',
            clickHandler: 'setSelectedMenuOption',
            isVisible: !canEdit,
            actionData: {
                title: 'Are you sure?',
                body: 'Leaving this conversation will not remove any of your connections; however, you will lose access to the conversation history.',
                cancelButton: 'Cancel',
                confirmButton: 'Leave',
                onCancel: 'cancelDialogAction',
                onConfirm: 'confirmDeleteConversation',
            },
        },
        reportConversationOption,
        {
            key: 'manageGroup',
            label: 'Manage Group',
            clickHandler: 'manageGroup',
            isVisible: canEdit && canManage,
        },
        {
            key: 'renameGroup',
            label: 'Rename Group',
            clickHandler: 'handleRenameGroup',
            isVisible: canEdit && canRename,
        },
        {
            key: 'policiesAndProcedures',
            label: 'Policies and Procedures',
            clickHandler: 'launchPnP',
            isVisible: true,
        },
    ];
};

